/** Normalize backend / UI action labels for consistent matching. */
export function normalizeActionName(actionName) {
  return String(actionName || "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ");
}

/**
 * Classify moderator review actions for button color system.
 * @returns {'safe'|'danger'|'neutral'}
 */
export function getActionType(actionName) {
  const normalized = normalizeActionName(actionName);

  const safeActions = [
    "publish",
    "could be published",
    "do not open a case",
    "do not open any case",
    "do not take action",
    "do not take any action",
  ];
  const dangerActions = ["open a case", "take action", "take an action"];
  const neutralActions = ["do not publish", "pending review"];

  if (safeActions.includes(normalized)) return "safe";
  if (dangerActions.includes(normalized)) return "danger";
  if (neutralActions.includes(normalized)) return "neutral";

  if (normalized.includes("do not open") && normalized.includes("case")) {
    return "safe";
  }
  if (normalized.includes("do not take") && normalized.includes("action")) {
    return "safe";
  }
  if (normalized.includes("do not publish")) return "neutral";
  if (normalized.includes("pending")) return "neutral";
  if (normalized.includes("open") && normalized.includes("case")) return "danger";
  if (normalized.includes("take") && normalized.includes("action")) {
    return "danger";
  }
  if (normalized === "publish" || normalized.endsWith(" published")) {
    return "safe";
  }

  return "neutral";
}

/** Tabler icon class for action type (requires tabler-icons webfont). */
export function getActionIconClass(actionType, actionName) {
  const normalized = normalizeActionName(actionName);
  if (actionType === "safe") return "ti ti-check";
  if (actionType === "danger") return "ti ti-alert-triangle";
  if (normalized.includes("do not publish")) return "ti ti-eye-off";
  return "ti ti-clock";
}

export const REVIEW_ACTION_TAG_SELECTOR = "[data-review-action-tag]";
